import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  checked: css``,
};
export const components = {
  icon: css``,
  label: css``,
  iconLayout: css``,
};

export const radio = css`
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  min-height: 1.5rem;
  font-size: 1rem;
  &[disabled] {
    cursor: not-allowed;
    color: ${theme.colors.neutral['50']};
  }

  & .${components.icon} {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    display: inline-flex;
    background: #ffffff;
    align-items: center;
    justify-content: center;
    border-width: 1px;
    border-style: solid;
    border-radius: 20px;
    color: transparent;
    border-color: ${theme.colors.neutral['95']};
    box-shadow: none;
    &[disabled] {
      border-color: ${theme.colors.neutral['50']};
      background: white;
    }

    &.${variants.checked} {
      background: ${theme.colors.neutral['95']};
      color: #ffffff;
      &[disabled] {
        background: ${theme.colors.neutral['50']};
        border-color: ${theme.colors.neutral['50']};
      }

      border-color: ${theme.colors.neutral['95']};
      box-shadow: 0 0 0 3px rgb(255 255 255) inset;
    }
  }

  & .${components.label} {
  }

  border-radius: 0;
  letter-spacing: 0.025em;
  &:hover:not([disabled]) {
    color: ${theme.colors.neutral['70']};

    & ${components.icon} {
      border-color: ${theme.colors.neutral['70']};

      &.${variants.checked} {
        background: ${theme.colors.neutral['70']};
      }
    }
  }

  & .${components.iconLayout} {
    display: flex;
    align-items: center;
    &::before {
      content: '\\00a0';
      width: 0;
    }
  }
`;
